(function() {
  if (window.KMCProductPagePolishLoaded) return;
  window.KMCProductPagePolishLoaded = true;

  function parseNumber(value) {
    var match = String(value == null ? '' : value).replace(',', '.').match(/-?\d+(?:\.\d+)?/);
    return match ? parseFloat(match[0]) : 0;
  }

  function compactNumber(value) {
    if (!isFinite(value)) return '';
    return Math.abs(value - Math.round(value)) < 0.05 ? String(Math.round(value)) : value.toFixed(1).replace(/\.0$/, '');
  }

  function readNutrition(scope) {
    var script = scope.querySelector('script[data-kmc-product-nutrition]') || document.querySelector('script[data-kmc-product-nutrition]');
    if (!script) return null;
    try { return JSON.parse(script.textContent || '{}'); } catch (error) { return null; }
  }

  function electrolyteMg(nutrition) {
    var salt = parseNumber(nutrition.salt);
    return salt > 0 ? Math.round(salt * 1000) : 0;
  }

  function vitaminValue(raw) {
    var text = String(raw || '').toUpperCase().replace(/\s+/g, ' ').trim();
    var matches = text.match(/B\d+/g) || [];
    if (matches.length) return matches.join(', ');
    return text.replace(/\s*,\s*/g, ', ');
  }

  function buildCard(value, label) {
    var li = document.createElement('li');
    var classes = ['icon-with-text__item', 'kmc-nutrition-stat-card'];
    if (label && /vitamin/i.test(label)) classes.push('kmc-nutrition-stat-card--b-vitamins');
    if (String(value || '').length > 9) classes.push('kmc-nutrition-stat-card--long');
    li.className = classes.join(' ');
    li.innerHTML = '<span class="kmc-nutrition-stat-card__value">' + value + '</span><span class="kmc-nutrition-stat-card__label">' + label + '</span>';
    return li;
  }

  function transformNutritionStats(scope) {
    var nutrition = readNutrition(scope);
    if (!nutrition) return;
    var statList = Array.prototype.find.call(scope.querySelectorAll('ul.icon-with-text--text-only'), function(list) {
      var text = list.textContent || '';
      return /Dual\s*-?\s*Carbs/i.test(text) && /Electrolytes/i.test(text);
    });
    if (!statList) return;

    var carbs = parseNumber(nutrition.carbohydrate);
    var electrolytes = electrolyteMg(nutrition);
    var vitamins = vitaminValue(nutrition.b_vitamins);

    statList.dataset.kmcNutritionStats = 'true';
    statList.classList.add('kmc-nutrition-stats');
    statList.innerHTML = '';

    if (carbs > 0) statList.appendChild(buildCard(compactNumber(carbs) + 'G', 'Dual Carbs'));
    if (electrolytes > 0) statList.appendChild(buildCard(compactNumber(electrolytes) + 'MG', 'Electrolytes'));
    if (vitamins) statList.appendChild(buildCard(vitamins, 'B Vitamins'));
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('product-info, .product__info-container'), transformNutritionStats);
  }

  var rafId;
  function queueRun() { window.cancelAnimationFrame(rafId); rafId = window.requestAnimationFrame(run); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queueRun); else queueRun();
  document.addEventListener('shopify:section:load', queueRun);
  new MutationObserver(queueRun).observe(document.documentElement, { childList: true, subtree: true });
})();
